import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signup-sign_up_to_shop_button-click';
/**
 * User click on sign up to shop button.
Record this event to FB Pixel and GTM
*/
export function trackSignupSignUpToShopButtonClick(pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'sign-up-to-shop-button',
        googleTagManagerEvent: 'sign-up-to-shop-button',
        pixelCustomDataParams: pixelCustomDataParams,
    });
}
